export class API {
  // ClinicManager Auth
  static clinicManagerLogin = 'clinic-manager/login'
  static clinicManagerLogout = 'clinic-manager/logout'
  static clinicManagerDetails = 'clinic-manager/details'
  static clinicManagerChangePassword = 'clinic-manager/change-password'
  static clinicManagerResetPassword = 'clinic-manager/reset-password'
  static clinicManagerAlterPasswordAfterReset = 'clinic-manager/alter-password-after-reset'
  static clinicManagerAlterEmail = 'clinic-manager/alter-email'
  static clinicManagerAlterName = 'clinic-manager/alter-name'
  static clinicManagerDelete = 'clinic-manager/delete'

  // Clinic
  static clinicDetails = 'clinic/details'
  static clinicUpdate = 'clinic/update'
  static clinicLogoUpload = 'clinic/logo/upload'

  // Content Blocks
  static contentBlockTypeList = 'clinic/content-block-type/list'
  static contentBlockList = 'clinic/content-block/list'
  static contentBlockCreate = 'clinic/content-block/create'
  static contentBlockUpdate = (key: string) => `clinic/content-block/${key}/update`
  static contentBlockReorder = (key: string) => `clinic/content-block/${key}/reorder`
  static contentBlockTogglePublish = (key: string) => `clinic/content-block/${key}/toggle-publish`
  static contentBlockToggleCollapsible = (key: string) => `clinic/content-block/${key}/toggle-collapsible`
  static contentBlockDelete = (key: string) => `clinic/content-block/${key}/delete`
  static contentBlockUploadMedia = (key: string) => `clinic/content-block/${key}/upload-media`

  // Media
  static clinicMedia = (filePath: string) => `clinic/media/${filePath}`
}
